// src/components/LandingPage.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const LandingPage = () => {
    const [displayText, setDisplayText] = useState('');
    const [isTyping, setIsTyping] = useState(true);
    const navigate = useNavigate();

    const fullText = `lamien@finai:~$ whoami
Financial AI Assistant
🚀 Real-time market analysis
📊 Advanced stock screening
💰 Portfolio optimization
📈 Technical analysis
🔔 Smart price alerts & notifications

lamien@finai:~$ python3 finai.py --mode=interactive
Starting Financial AI Assistant...
Loading market data... ✓
Initializing AI models... ✓
Ready for financial analysis.

Click on '/Start' to create an account or login to continue`;

    useEffect(() => {
        let i = 0;
        const typingInterval = setInterval(() => {
            if (i < fullText.length) {
                setDisplayText(fullText.slice(0, i + 1));
                i++;
            } else {
                setIsTyping(false);
                clearInterval(typingInterval);
            }
        }, 50);

        return () => clearInterval(typingInterval);
    }, [fullText]);

    const handleAuthClick = () => {
        navigate('/login');
    };

    return (
        <div className="min-h-screen bg-black text-green-400 font-mono relative overflow-hidden">
            {/* Bouton Login dans le coin */}
            <button
                onClick={handleAuthClick}
                className="absolute top-6 right-6 px-6 py-2 bg-green-600 hover:bg-green-700 
                         text-black font-semibold rounded-md transition-colors duration-200
                         shadow-lg hover:shadow-green-500/25"
            >
                /Start
            </button>

            {/* Terminal principal */}
            <div className="flex items-center justify-center min-h-screen p-4">
                <div className="w-full max-w-4xl bg-gray-900 rounded-lg shadow-2xl border border-gray-700">
                    {/* Barre de titre du terminal */}
                    <div className="flex items-center justify-between px-4 py-2 bg-gray-800 rounded-t-lg border-b border-gray-700">
                        <div className="flex items-center space-x-2">
                            <div className="w-3 h-3 bg-red-500 rounded-full"></div>
                            <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
                            <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                        </div>
                        <div className="text-gray-400 text-sm">lamien your personnal Finance assistant - $Money_loading</div>
                        <div className="w-16"></div>
                    </div>

                    {/* Contenu du terminal */}
                    <div className="p-6 h-96 overflow-y-auto">
                        <pre className="text-sm leading-relaxed whitespace-pre-wrap">
                            {displayText}
                            {isTyping ? (
                                <span className="animate-pulse bg-green-400 text-green-400">█</span>
                            ) : (
                                <span className="animate-blink text-green-400">_</span>
                            )}
                        </pre>
                    </div>
                </div>
            </div>

            {/* Animation de particules en arrière-plan */}
            <div className="absolute inset-0 pointer-events-none">
                <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-green-400 rounded-full animate-ping opacity-20"></div>
                <div className="absolute top-3/4 right-1/4 w-1 h-1 bg-blue-400 rounded-full animate-pulse opacity-30"></div>
                <div className="absolute bottom-1/4 left-1/3 w-1.5 h-1.5 bg-yellow-400 rounded-full animate-bounce opacity-25"></div>
            </div>

            {/* Effet de grille en arrière-plan */}
            <div className="absolute inset-0 bg-grid-pattern opacity-5 pointer-events-none"></div>
        </div>
    );
};

export default LandingPage;